var colorCounter = 0;

function hexHalf(h) {
    return Math.floor(parseInt(h, 16) / 2).toString(16)
  }

  function halfDark(color) {
    return '#' + hexHalf(color.substring(1, 3)) + hexHalf(color.substring(3, 5)) + hexHalf(color.substring(5, 7))
  }
  
  
export const fillColors = [
    '#1f78b4',
    '#b2df8a',
    '#33a02c',
    '#fb9a99',
    '#e31a1c',
    '#fdbf6f',
    '#ff7f00',
    '#cab2d6',
    '#6a3d9a',
    '#ffff99',
    '#b15928',
    '#a6cee3'
  ];

  export function featureStyleWithConfig(config) {
    return function featureStyle(feature) {
      var color = fillColors[(colorCounter++) % fillColors.length];
      if (feature.properties && feature.properties.style) {
        return feature.properties.style;
      }
      if (config.style) {
        return config.style
      }
      if (feature.geometry.type === 'Polygon' || feature.geometry.type === 'MultiPolygon') {
        return {
          color: halfDark(color),
          fillColor: color,
          opacity: 0.9,
          weight: 0.5,
          fillOpacity: 0.35,
          dashArray: [1, 1]
        };
      } else {
        return {
          color: '#000',
          weight: 1,
          lineCap: 'none'
        }
      }
  
    }
  }
  